import React from "react";
import classes from "./index.module.css";
import rfShare from "../../assets/rfc_share.png";
import rfProfile from "../../assets/rfc_profile.png";
import rfBook from "../../assets/rfc_book.png";
import rfReward from "../../assets/rfc_reward.png";

const steps = [
  {
    icon: rfShare,
    title: "Step 1:",
    description: "Share your unique referral link with a friend or submit their details in the referral form.",
  },
  {
    icon: rfProfile,
    title: "Step 2:",
    description: "Your friend signs up and attends a demo class",
  },
  {
    icon: rfBook,
    title: "Step 3:",
    description:
      "Your friend enrolls in a course and completes 45 days of learning",
  },
  {
    icon: rfReward,
    title: "Step 4:",
    description:
      "Reward points are credited to you - redeem anytime",
  },
];

const ReferralInfo = () => {
  return (
    <div className={classes.stepsContainer}>
      {steps?.map((step, index) => (
        <div key={index} className={classes.stepCard}>
          <img
            src={step?.icon}
            alt={step?.title}
            className={classes.stepIcon}
          />
          <div className={classes.stepTextContainer}>
            <p className={classes.stepTitle}>{step?.title}</p>
            <p className={classes.stepDescription}>{step?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReferralInfo;


